import { render, staticRenderFns } from "./DonorDetails.vue?vue&type=template&id=248b02ae"
import script from "./DonorDetails.vue?vue&type=script&lang=js"
export * from "./DonorDetails.vue?vue&type=script&lang=js"
import style0 from "./DonorDetails.vue?vue&type=style&index=0&id=248b02ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports